export default {
  share: {
    fullUrl: 'Complet',
    clickToCopy: 'Faceți clic pentru a copia URL-ul',
    share: 'Partajați (click pentru a copia)',
    shareLink: 'Partajați link-ul',
    short: 'URL scurt',
    embedCodeCopied: 'Cod de încorporare copiat',
    embed: 'Integrare (click pentru a copia)',
    embedInstructions: 'Utilizați acest cod pentru a încorpora harta ORS în site-ul dumneavoastră',
    shortUrl: 'Scurt',
    urlCopied: 'URL copiat în clipboard.',
    copyUrlInfo: 'De asemenea, puteți copia linkul din bara de adrese a browserului dumneavoastră.',
    urlShortened: 'URL scurtat',
    shorteningNotPossible: 'Nu a fost posibilă generarea unui URL scurt. Vă rugăm să utilizați URL-ul complet',
  }
}
